// extracted by mini-css-extract-plugin
export default {"plateStatus":"plateStatus-sBELL","checkedIn":"checkedIn-FI_vJ","checkedOut":"checkedOut-JL7gO"};